import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import AboutMe from './AboutMe';
import WorkExperience from './WorkExperience';
import PersonalProjects from './PersonalProjects';
import ContactMe from './ContactMe';

const Home = ({
  title,
  menuOpts,
  expandedMenu,
  handleExpandedMenu,
  handleLanguages,
  languagesOpts,
  aboutMe,
  aboutMeIcons,
  knowingMe,
  handleKnowingMe,
  workTitle,
  startups,
  projectsTitle,
  projects,
  social,
  socialIcons
}) => (
  <Fragment>
    <Header
      title={title}
      menuOpts={menuOpts}
      handleLanguage={handleLanguages}
      languagesOpts={languagesOpts}
      expandedMenu={expandedMenu}
      handleExpandedMenu={handleExpandedMenu}
    />
    <AboutMe
      aboutMe={aboutMe}
      knowingMe={knowingMe}
      handleKnowingMe={handleKnowingMe}
      aboutMeIcons={aboutMeIcons}
    />
    <WorkExperience title={workTitle} startups={startups} />
    <PersonalProjects title={projectsTitle} projects={projects} />
    <ContactMe social={social} socialIcons={socialIcons} />
  </Fragment>
);

Home.propTypes = {
  title: PropTypes.array,
  menuOpts: PropTypes.array,
  expandedMenu: PropTypes.bool,
  handleExpandedMenu: PropTypes.func,
  handleLanguages: PropTypes.func,
  languagesOpts: PropTypes.array,
  aboutMe: PropTypes.object,
  aboutMeIcons: PropTypes.array,
  knowingMe: PropTypes.bool,
  handleKnowingMe: PropTypes.func,
  workTitle: PropTypes.string,
  startups: PropTypes.array,
  projectsTitle: PropTypes.string,
  projects: PropTypes.array,
  social: PropTypes.object,
  socialIcons: PropTypes.array
};

export default Home;
